import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    const dateString = this.element.getAttribute('data-value')
    if (!dateString) return

    const utcDate = new Date(dateString)
    const date = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000)
    this.element.value = date.toISOString().slice(0, 16)
  }
}
